
const DocIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clipPath="url(#clip0_135_6947)">
                <path d="M9.33301 2V4.66667C9.33301 4.84348 9.40325 5.01305 9.52827 5.13807C9.65329 5.2631 9.82286 5.33333 9.99967 5.33333H12.6663" stroke="#475467" strokeWidth="0.933333" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M11.333 14H4.66634C4.31272 14 3.97358 13.8595 3.72353 13.6095C3.47348 13.3594 3.33301 13.0203 3.33301 12.6667V3.33333C3.33301 2.97971 3.47348 2.64057 3.72353 2.39052C3.97358 2.14048 4.31272 2 4.66634 2H9.33301L12.6663 5.33333V12.6667C12.6663 13.0203 12.5259 13.3594 12.2758 13.6095C12.0258 13.8595 11.6866 14 11.333 14Z" stroke="#475467" strokeWidth="0.933333" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6 6H6.66667" stroke="#475467" strokeWidth="0.933333" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6 8.66675H10" stroke="#475467" strokeWidth="0.933333" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6 11.3333H10" stroke="#475467" strokeWidth="0.933333" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_135_6947">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default DocIcon